<template>
  <b-container fluid>
      <b-row >
        <b-col lg="12" sm="12" md="12" xl="12">
            <iq-card>
                <template v-slot:headerTitle>
                    <h4 class="card-title text-center">{{ $t('promotionManagement.promotion_dashboard') }}</h4>
                </template>
                <b-overlay :show="loading">
                    <template>
                        <div v-if="dashboardData.ongoing_list.length > 0">
                            <b-row class="mt-5">
                                <b-col md='10' offset-md='1'>
                                    <div class="promotion-list">
                                        <b-row>
                                            <b-col lg="6" sm="12" class="text-dark text-size">
                                                <b-row>
                                                    <b-col lg="5" sm="12">
                                                        <p class="text-dark" style='font-weight:bold'>{{$t('promotionManagement.promotion_title')}}</p>
                                                    </b-col>
                                                    <b-col lg="7" sm="12">
                                                    <p> : {{ i18 ? dashboardData.ongoing_list[totalOngoingPromotionCount].promotion_title_bn : dashboardData.ongoing_list[totalOngoingPromotionCount].promotion_title }}</p>
                                                    </b-col>
                                                </b-row>
                                                <b-row>
                                                    <b-col lg="5" sm="12">
                                                        <p class="text-dark" style='font-weight:bold'>{{$t('externalUser.production.promotion_type')}}</p>
                                                    </b-col>
                                                    <b-col lg="7" sm="12">
                                                    <p> : {{ i18 ? dashboardData.ongoing_list[totalOngoingPromotionCount].promotion_type_bn : dashboardData.ongoing_list[totalOngoingPromotionCount].promotion_type_en }}</p>
                                                    </b-col>
                                                </b-row>
                                                <b-row>
                                                    <b-col lg="5" sm="12">
                                                        <p class="text-dark" style='font-weight:bold'>{{$t('externalUser.production.promotion_spot')}}</p>
                                                    </b-col>
                                                    <b-col lg="7" sm="12">
                                                    <p> : {{ i18 ? dashboardData.ongoing_list[totalOngoingPromotionCount].promotion_spot_bn : dashboardData.ongoing_list[totalOngoingPromotionCount].promotion_spot }}</p>
                                                    </b-col>
                                                </b-row>
                                                <b-row>
                                                    <b-col lg="5" sm="12">
                                                        <p class="text-dark" style='font-weight:bold'>{{$t('externalUser.production.start_time')}}</p>
                                                    </b-col>
                                                    <b-col lg="7" sm="12">
                                                    <p> : {{ dashboardData.ongoing_list[totalOngoingPromotionCount].from_date | dateFormat }}</p>
                                                    </b-col>
                                                </b-row>
                                                <b-row>
                                                    <b-col lg="5" sm="12">
                                                        <p class="text-dark" style='font-weight:bold'>{{$t('externalUser.production.end_time')}}</p>
                                                    </b-col>
                                                    <b-col lg="7" sm="12">
                                                    <p> : {{ dashboardData.ongoing_list[totalOngoingPromotionCount].to_date | dateFormat }}</p>
                                                    </b-col>
                                                </b-row>
                                            </b-col>
                                            <b-col lg="6" sm="12" v-if="dashboardData.ongoing_list[totalOngoingPromotionCount].promotion_type_id === 1">
                                                <div class="overlay-data">
                                                    <span class="count-down">{{ ((9 >= countDown) ? '0' : '') + countDown }}</span>
                                                </div>
                                                <b-img @error="imageLoadError" style="border-radius:4px; width:100%;height:200px" :src="dashboardData.ongoing_list[totalOngoingPromotionCount].attachment" aria-placeholder="view image" alt="Promotion image"></b-img>
                                            </b-col>
                                            <b-col lg="6" sm="12" v-if="dashboardData.ongoing_list[totalOngoingPromotionCount].promotion_type_id === 2">
                                                <div class="overlay-data">
                                                    <span class="count-down">{{ ((9 >= countDown) ? '0' : '') + countDown }}</span>
                                                </div>
                                                <iframe width="100%" height="200px" :src="dashboardData.ongoing_list[totalOngoingPromotionCount].attachment" frameborder="0" allowfullscreen></iframe>
                                                <!-- <b-img @error="imageLoadError" style="border-radius:4px; width:100%;height:200px" :src="dashboardData.ongoing_list[totalOngoingPromotionCount].attachment" aria-placeholder="view image" alt="Promotion image"></b-img> -->
                                            </b-col>
                                            <b-col lg="6" sm="12" v-if="dashboardData.ongoing_list[totalOngoingPromotionCount].promotion_type_id === 3">
                                                <div class="overlay-data">
                                                    <span class="count-down">{{ ((9 >= countDown) ? '0' : '') + countDown }}</span>
                                                </div>
                                                <b-img @error="imageLoadError" style="border-radius:4px; width:100%;height:200px" :src="dashboardData.ongoing_list[totalOngoingPromotionCount].attachment" aria-placeholder="view image" alt="Promotion image"></b-img>
                                            </b-col>
                                        </b-row>
                                    </div>
                                </b-col>
                            </b-row>
                        </div>
                        <b-row class="justify-content-center mt-3 text-size-box">
                            <b-col md="3" sm="3" lg="3" xl="3" class="custom-box-shadow">
                                <div class="mt-3 p-3 rounded mb-3 text-center" :style="myStyle">
                                <h5 class="text-white" :style="Style">{{ $t('promotionManagement.ongoing_promotion') }}</h5>
                                <hr>
                                <h4 class="text-white rounded border">{{ dashboardData.total_ongoing.total }}</h4>
                                </div>
                            </b-col>
                            <b-col md="3" sm="3" lg="3" xl="3" class="custom-box-shadow">
                                <div class="mt-3 p-3 rounded mb-3 text-center" :style="myStyle">
                                <h5 class="text-white" :style="Style">{{ $t('promotionManagement.upcoming_promotion') }}</h5>
                                <hr>
                                <h4 class="text-white rounded border">{{ dashboardData.total_upcomming.total }}</h4>
                                </div>
                            </b-col>
                            <b-col md="3" sm="3" lg="3" xl="3" class="custom-box-shadow">
                                <div class="mt-3 p-3 rounded mb-3 text-center" :style="myStyle">
                                <h5 class="text-white" :style="Style">{{ $t('promotionManagement.complete_promotion') }}</h5>
                                <hr>
                                <h4 class="text-white rounded border">{{ dashboardData.total_completed.total }}</h4>
                                </div>
                            </b-col>
                        </b-row>
                        <br>
                    </template>
                    <!-- <pre>{{dashboardData.ongoing_list[totalOngoingPromotionCount].promotion_type_id}}</pre> -->
                </b-overlay>
            </iq-card>
        </b-col>
      </b-row>
    </b-container>
</template>
<script>
import { core } from '@/config/pluginInit'
import RestApi, { productionServiceBaseUrl } from '@/config/api_config'
import { promotionDashboard } from '../../api/routes'

export default {
  created () {
    this.loadData()
  },
  mounted () {
    core.index()
    this.countDownTimer()
  },
  data () {
    return {
    countDown: 10,
    totalOngoingPromotionCount: 0,
    totalPromotion: 0,
    mainProps: { blank: true, blankColor: '#777', width: 75, height: 75, class: 'm1' },
    myStyle: {
        backgroundColor: '#005B5B'
    },
    Style: {
        fontSize: '16px'
    },
    dashboardData: [],
    singleData: {},
    loading: false
    }
  },
  computed: {
    i18 () {
      return (this.$i18n.locale === 'bn') ? 1 : 0
    }
  },
  methods: {
    imageLoadError () {
      this.dashboardData.ongoing_list[this.totalOngoingPromotionCount].attachment = '/images/not_found.png'
    },
    loadData () {
        this.loading = true
        RestApi.getData(productionServiceBaseUrl, promotionDashboard)
        .then(response => {
            this.loading = false
            if (response.success) {
                const details = response.data.ongoing_list.map(item => {
                    if (item.promotion_type_id !== 2) {
                        return Object.assign(item, {
                            attachment: productionServiceBaseUrl + 'download-attachment?file=' + item.attachment
                        })
                    } else {
                        return Object.assign(item, {
                            attachment: item.attachment + '?mute=1&rel=0&version=3&autoplay=1&controls=1&showinfo=0&loop=1'
                        })
                    }
                })
                this.dashboardData = Object.assign(response.data, { ongoing_list: details })
                this.totalPromotion = response.data.ongoing_list.length
                if (this.dashboardData.ongoing_list[0].promotion_type_id === 2) {
                    const dur = this.dashboardData.ongoing_list[0].duration
                    this.countDown = parseInt(dur)
                } else {
                    this.countDown = 10
                }
            }
        })
    },
    countDownTimer () {
        setTimeout(() => {
            this.countDown -= 1
            this.countDownTimer()
            if (this.countDown === 0) {
                if (this.totalOngoingPromotionCount === this.totalPromotion) {
                    this.totalOngoingPromotionCount = 0
                } else {
                    this.totalOngoingPromotionCount += 1
                }
                if (this.dashboardData.ongoing_list[this.totalOngoingPromotionCount].promotion_type_id === 2) {
                    const dur = this.dashboardData.ongoing_list[this.totalOngoingPromotionCount].duration
                    this.countDown = parseInt(dur)
                } else {
                    this.countDown = 10
                }
            }
        }, 1000)
    }
  }
}
</script>
<style>
  .hidden_header {
    display: none
  }
  .card-border {
    border: 1px solid #b9bdc1;
    box-shadow: 1px 1px 6px -1px grey;
    background-color: #dee2e6;
  }
  [dir=ltr][mode=light] .card-body {
    flex: 1 1 auto;
    min-height: 1px;
    padding: 10px;
  }
  .report-name{
    font-weight: bold !important;
    text-transform: uppercase;
  }
  .my-btn{
    padding: 2px !important;
  }
  .count-down {
    padding: 2px 8px 2px 8px;
    border: 1px solid black;
    font-size: 21px;
    background: #609513;
    color: white;
    visibility: hidden;
  }
  .text-size {
    padding: 0px;
    font-size: 16px;
  }
  .text-size-box {
    padding: 0px;
    font-size: 16px;
  }
  .overlay-data {
      position: absolute;
      right: 20px;
      bottom: 8px;
  }
  .promotion-list {
    border: 1px solid gray;
    padding: 20px;
    box-shadow: 0px 2px 6px grey;
    border-radius: 8px;
  }
</style>
